import { OAuthClientAuth } from '@recruitee/http-types';
import { createSingleEntityStore, PickActions } from '@recruitee/ngrx';

const { actions, reducer, namespace, selectors } =
  createSingleEntityStore<OAuthClientAuth[]>()('OAuthClientAuth');

const OAuthClientAuthActions: PickActions<typeof actions, 'fetch'> = actions;

export {
  OAuthClientAuthActions,
  reducer as OAuthClientAuthReducer,
  namespace as OAuthClientAuthNamespace,
  selectors as OAuthClientAuthSelectors,
};
